/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/structural_template/canvas_template_tags" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdStructuralTemplateCanvasTemplateTags } from "./constants";
import type { EngagementAppGroupIdStructuralTemplateCanvasTemplateTagsResult } from "./types";

export const getEngagementAppGroupIdStructuralTemplateCanvasTemplateTags = reactQueryFetcherAdapter(
  engagementAppGroupIdStructuralTemplateCanvasTemplateTags,
  (
    signal: AbortSignal,
    appGroupId: string
  ): Promise<EngagementAppGroupIdStructuralTemplateCanvasTemplateTagsResult> => {
    return fetch(`/engagement/${appGroupId}/structural_template/canvas_template_tags`, "GET", {}, { signal });
  }
);
